import React from "react";
import styles from "./Whyimporc.module.css";

const WhyimporcMentor = () => {
  return (
    <div className={styles.blueBorderBlock}>
      <div className={styles.heading}>
        <h4>Benefits of IMPARC Mentorship Program</h4>
      </div>
      <div className={styles.content}>
        <h5>Engagement in the IMPARC Knowledge Series</h5>
        <p>
          Actively participate in high-impact academic initiatives including
          webinars, conferences, workshops, seminars, FDP's, and expert panels
          as a speaker, reviewer, moderator, editor, or subject expert.
        </p>
        <h5>Speaker Role in IMPARC WAAS Series</h5>
        <p>
          Share your expertise as a speaker in the IMPARC Weekly Academic
          Advancement Series (WAAS), engaging with a diverse and global academic
          audience.
        </p>
        <h5>Prestigious Award Nomination</h5>
        <p>
          Become eligible for nomination to the Ignited Minds Global Academic
          Excellence Awards, recognizing excellence, innovation, leadership, and
          meaningful academic impact.
        </p>
        <h5>Feature in Ignited Minds Today</h5>
        <p>
          Get featured in Ignited Minds Today, an international print magazine,
          showcasing your academic journey, thought leadership, and mentorship
          influence.
        </p>
        <h5>Featured Mentor Profile on Website & Social Media</h5>
        <p>
          Receive a dedicated mentor profile on IMPARC’s official website and
          social media platforms, highlighting your academic achievements and
          professional contributions.
        </p>
        <h5>Mentorship Certificate along with a Welcome Kit</h5>
        <p>
          Receive a Certificate of Mentorship along with a welcome kit,
          recognizing your contribution to academic guidance and research
          development.
        </p>
        <h5>Global Visibility & Academic Recognition</h5>
        <p>
          Strengthen your national and international academic presence through
          global events, collaborations, and international outreach facilitated
          via the MentorsGate network.
        </p>
        <h5>Access to Research Associate Privileges</h5>
        <p>
          Enjoy complimentary paper publishing support and dedicated research
          assistance under the Research Associate Program.
        </p>
        <h5>Refer & Earn Program</h5>
        <p>
          Earn 30% of the publishing fee for every author or researcher you
          refer to IMPARC for publishing and research support services.
        </p>{" "}
      </div>
    </div>
  );
};

export default WhyimporcMentor;
